import FooterBrandInfo from './sections/FooterBrandInfo';
import FooterContactInfo from './sections/FooterContactInfo';
import FooterCopyright from './sections/FooterCopyright';

const FooterSection = () => {
  return (
    <footer className="bg-gray-50 text-gray-800 pt-12 sm:pt-16 md:pt-20 pb-8 sm:pb-10 px-4 sm:px-8 md:px-12 lg:px-20 relative overflow-hidden border-t border-gray-200">
      <div className="max-w-7xl 2xl:max-w-[1600px] mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12 mb-10 sm:mb-16">
          {/* Brand Info & Social Links */}
          <FooterBrandInfo />

          {/* Contact & Office Address */}
          <FooterContactInfo />
        </div>

        {/* Copyright & Disclaimer */}
        <FooterCopyright />
      </div>
    </footer>
  );
};

export default FooterSection;
